import React, {
    useState
}
from "react";

import {
    TAB_GRADIENT,
    OMNISCAN_BLUE,
    TEXT_LIGHT
}
from "../constants/colors";


export default function MetricKpiBox({

    value,

    label,

    color = OMNISCAN_BLUE,

    isActive = false,

    onClick

})
{

    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [isHover, setIsHover] =
        useState(false);


    //========================================================
    // Styles
    //========================================================

    const containerStyle =
    {

        flex:
            1,

        height:
            "70px",

        //----------------------------------------------------
        // Structural card = square
        //----------------------------------------------------

        borderRadius:
            "0px",

        cursor:

            onClick

                ?

                "pointer"

                :

                "default",

        //----------------------------------------------------
        // Dark graphite treatment
        //----------------------------------------------------

        background:

            isActive

                ?

                "linear-gradient(180deg,#20262c 0%,#101418 100%)"

                :

                TAB_GRADIENT,

        //----------------------------------------------------
        // Fine structural definition
        //----------------------------------------------------

        border:
            "1px solid rgba(255,255,255,0.08)",

        borderBottom:

            isActive || (isHover && onClick)

                ?

                "2px solid #20afe8"

                :

                "1px solid rgba(255,255,255,0.08)",

        //----------------------------------------------------
        // Restrained depth
        //----------------------------------------------------

        boxShadow:

            isHover && onClick

                ?

                `
                0 4px 10px rgba(0,0,0,0.16),
                0 8px 20px rgba(7,28,49,0.16)
                `

                :

                `
                0 2px 5px rgba(0,0,0,0.12),
                0 6px 16px rgba(7,28,49,0.12)
                `,

        //----------------------------------------------------
        // No floating / bouncing card
        //----------------------------------------------------

        transform:
            "translateY(0px)",

        transition:
            "border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease",

        display:
            "flex",

        flexDirection:
            "column",

        justifyContent:
            "center",

        alignItems:
            "center",

        boxSizing:
            "border-box"

    };


    const valueStyle =
    {

        fontSize:
            "24px",

        fontWeight:
            "400",

        color:
            color,

        lineHeight:
            "1.1"

    };


    const labelStyle =
    {

        fontSize:
            "12px",

        color:
            TEXT_LIGHT,

        marginTop:
            "6px",

        textAlign:
            "center",

        fontWeight:
            "400",

        letterSpacing:
            "0.15px"

    };


    //========================================================
    // Render
    //========================================================

    return (

        <div

            style={
                containerStyle
            }

            onClick={
                onClick
            }

            onMouseEnter={
                function()
                {

                    if(onClick)
                    {

                        setIsHover(
                            true
                        );

                    }

                }
            }

            onMouseLeave={
                function()
                {

                    setIsHover(
                        false
                    );

                }
            }

        >

            <div style={valueStyle}>

                {value}

            </div>

            <div style={labelStyle}>

                {label}

            </div>

        </div>

    );

}